import lookup from 'country-code-lookup';

interface IDescribeCountry {
  continent: string,
  region: string,
  country: string,
  capital: string,
  fips: string,
  iso2: string,
  iso3: string,
  isoNo: string,
  internet:string,
}

export const getCountryCodeByName = (val:string | null) => {
  if (val) {
    if (val === 'USA' || val === 'US') {
      const code = lookup.byCountry('United States') as IDescribeCountry;
      return code.internet.toLowerCase();
    }
    const code = lookup.byCountry(val) as IDescribeCountry;
    return code.internet.toLowerCase();
  }
  return null;
};
